"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreCollection = exports.FIRESTORE_COLLECTION_LIMIT = void 0;
exports.FIRESTORE_COLLECTION_LIMIT = 1000;
var FirestoreCollection;
(function (FirestoreCollection) {
    FirestoreCollection["APP_CONFIG"] = "appConfig";
    FirestoreCollection["WAREHOUSES"] = "warehouses";
    FirestoreCollection["WAREHOUSE_CONFIGS"] = "warehouseConfigs";
    FirestoreCollection["WAREHOUSE_STATS"] = "warehouseStats";
    FirestoreCollection["CATEGORIES"] = "categories";
    FirestoreCollection["ORDERS"] = "orders";
    FirestoreCollection["WAITING_CUSTOMERS"] = "waitingCustomers";
    FirestoreCollection["ORDER_RATINGS"] = "orderRatings";
    FirestoreCollection["COUNTRIES"] = "countries";
    FirestoreCollection["CUSTOMERS"] = "customers";
    FirestoreCollection["DEVICES"] = "devices";
    FirestoreCollection["USERS"] = "users";
    FirestoreCollection["CHECKOUTS"] = "checkouts";
    FirestoreCollection["CHECKOUT_REMINDERS"] = "checkoutReminders";
    FirestoreCollection["ORDER_DETAILS"] = "orderDetails";
    FirestoreCollection["PHONE_VALIDATION_KEYS"] = "phoneValidationKeys";
    FirestoreCollection["VARIANT_DOWNLOAD_LIST"] = "variantDownloadList";
    FirestoreCollection["STOCK_ADJUSTMENTS"] = "stockAdjustments";
    FirestoreCollection["PURCHASE_ORDERS"] = "purchaseOrders";
    FirestoreCollection["ONFLEET_TASKS"] = "onfleetTasks";
    FirestoreCollection["ONFLEET_TEAMS"] = "onfleetTeams";
    FirestoreCollection["ONFLEET_WORKERS"] = "onfleetWorkers";
    FirestoreCollection["SEARCH_AND_CATALOGUE"] = "searchAndCatalogue";
})(FirestoreCollection = exports.FirestoreCollection || (exports.FirestoreCollection = {}));
